(() => {
  if (window.bvDialogLayoutInitialized) return;
  window.bvDialogLayoutInitialized = true;
  const root = document.documentElement;
  const enhancedButtons = new WeakSet();
  let frame = 0;
  let watched = [];
  const visible = element => {
    if (!element || element.hidden) return false;
    const rect = element.getBoundingClientRect();
    const style = getComputedStyle(element);
    return rect.width > 0 && rect.height > 0 && style.display !== 'none' && style.visibility !== 'hidden';
  };
  const schedule = () => {
    if (!frame) frame = requestAnimationFrame(update);
  };
  const observer = new ResizeObserver(schedule);
  function update() {
    frame = 0;
    const age = document.getElementById('av-overlay-form');
    const banner = document.getElementById('shopify-pc__banner');
    const preview = document.getElementById('PBarNextFrameWrapper');
    const ageOpen = visible(age);
    const cookieOpen = visible(banner);
    root.toggleAttribute('data-bv-age-open', ageOpen);
    root.toggleAttribute('data-bv-cookie-open', cookieOpen);
    const previewHeight = visible(preview) ? preview.getBoundingClientRect().height : 0;
    const cookieHeight = ageOpen && cookieOpen ? banner.getBoundingClientRect().height : 0;
    root.style.setProperty('--bv-preview-height', `${Math.ceil(previewHeight)}px`);
    root.style.setProperty('--bv-age-space', `${Math.max(96, innerHeight - cookieHeight - previewHeight)}px`);
    const next = [age, banner, preview].filter(Boolean);
    if (next.length !== watched.length || next.some((el, i) => el !== watched[i])) {
      observer.disconnect();
      next.forEach(el => observer.observe(el));
      watched = next;
    }
    if (age) {
      const heading = age.querySelector('.headline_text');
      if (heading) {
        if (!heading.id) heading.id = 'bv-age-dialog-title';
        age.setAttribute('role', 'dialog');
        age.setAttribute('aria-labelledby', heading.id);
      }
      age.querySelectorAll('a#av_submit_form, a#av_cancel_form').forEach(button => {
        if (enhancedButtons.has(button)) return;
        enhancedButtons.add(button);
        button.setAttribute('role', 'button');
        button.tabIndex = 0;
        button.addEventListener('keydown', event => {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          button.click();
        });
      });
    }
  }
  new MutationObserver(schedule).observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'style', 'hidden']
  });
  addEventListener('resize', schedule, { passive: true });
  addEventListener('pageshow', schedule);
  schedule();
})();
